import { useState } from "react";
import { Utils } from "../../common/views/Utils";
import { PopUpType } from "../../home/models/OtherTypes";
import { ShortWebsiteModel } from "../models/WebsiteModel";

export function useWebsitePickerVM(options: ShortWebsiteModel[], type: PopUpType) {
    const [value, setValue] = useState<number | undefined>(undefined);
    const [text, setText] = useState<string>("");

    const [filteredOptions, setFilteredOptions] = useState<ShortWebsiteModel[]>([]);
    const [recentItems, setRecentItems] = useState<any[]>([]);

    const [showMenu, setShowMenu] = useState<boolean>(false);
    const [listHash, setListHash] = useState<number>(0);

    const onTextChange = (newValue: string) => {
        const req = new RegExp(newValue, 'i');
        const newOptions = options.filter((value: ShortWebsiteModel) => req.test(value.name));

        setFilteredOptions(newOptions);
        setListHash(Utils.getRandomKey());
    }

    const filteredByLetter = (letter: string) => {
        const newOptions = options.filter((value: ShortWebsiteModel) =>
            value.name.substr(0, 1).toUpperCase() === letter);

        setFilteredOptions(newOptions);
        setListHash(Utils.getRandomKey());
    }

    const onSelectedChange = (option: ShortWebsiteModel) => {
        const value = option.id as number;
        setValue(value);
        setText(option.name);
        setShowMenu(type === PopUpType.panel);

        if (recentItems && !recentItems.find((item: any) => item.value === value)) {
            setRecentItems(prev => {
                const copy = [...prev];
                copy.unshift({ value: value, text: option.name });
                return copy;
            });
        }
    }

    const onClear = () => {
        setValue(undefined);
        setText("");
    }

    const onRecentClick = (item: any) => {
        setValue(item.value);
        setText(item.text);
        setShowMenu(type === PopUpType.panel);
    }

    const getText = (value?: number) => {
        if (!value) return "";

        const option = options && options.find((opt) => opt.id === value);

        if (option) {
            var text = option.name;

            if (option.earningPointRate > 0) {
                text += " (" + option.earningPointRate + "%)";
            }

            return text;
        }

        return "";
    }

    const onShowMenu = () => {
        setShowMenu(true);
        setFilteredOptions(options);
    }

    return {
        value,
        text,
        filteredOptions,
        recentItems,
        showMenu,
        setShowMenu,
        listHash,

        onShowMenu,
        onTextChange,
        filteredByLetter,
        onSelectedChange,
        onClear,
        onRecentClick,
        getText
    }
}